export default "__VITE_ASSET__BHEJKcsd__"